import { render, staticRenderFns } from "./pourquoi-la-typographie-est-un-element-cle-dans-vos-supports-de-communication.vue?vue&type=template&id=3e88c1c2&"
import script from "./pourquoi-la-typographie-est-un-element-cle-dans-vos-supports-de-communication.vue?vue&type=script&lang=js&"
export * from "./pourquoi-la-typographie-est-un-element-cle-dans-vos-supports-de-communication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports